export const state = () => ({})

export const mutations = {}

export const actions = {
    async login({}, email) {
        if (!email) throw new Error('Error: [external/login] - missing email')
        return await this.$axios.$post('/api/v1/external/idc_login', { email: email })
    },
}
